// extracted by mini-css-extract-plugin
export default {"brandPromo":"cH-z","carousel":"dH-z"};